import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUsers = ({ name, page, courseGroups, userGroup, onlineDeltaTime, showCompletedChallenges, enabled = true }) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  
  return useQuery({
    queryKey: ['users', { name, page, courseGroups, userGroup, onlineDeltaTime, showCompletedChallenges }],
    queryFn: async () => {
      const result = await restClient({ 
        url: `${prefix}/users`, 
        method: 'post',
        data: {
          name,
          page,
          courseGroups,
          userGroup,
          onlineDeltaTime,
          showCompletedChallenges
        }
      });
      return result;
    },
    enabled,
    staleTime: 0,
    cacheTime: 0, 
    refetchOnWindowFocus: false,
  });
};
